import { render } from "./ReactiveUserModalComponent.vue?vue&type=template&id=645cdfa2"
import script from "./ReactiveUserModalComponent.vue?vue&type=script&lang=js"
export * from "./ReactiveUserModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__